const doc = [({"ja":({"adminConstantHotelInventoryStatus":({"onSale":"販売中", "saleStopped":"販売停止"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;